import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M6 19h4V5H6v14zm8-14v14h4V5h-4z"
}), 'PauseOutlined');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/PauseOutlined.js
// module id = 5227
// module chunks = 2